// removed by extract-text-webpack-plugin
module.exports = {"dropdown-menu":"dropdown-menu___3AXnA","title":"title___3NhcW","triangle":"triangle___2cjQJ","popover":"popover___2POSX","calendar":"calendar___zn6KH","dropdown-pop-up":"dropdown-pop-up___3FgF7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DropDownMenu/DropDownMenu.scss
// module id = 8g7e
// module chunks = 46